import React, { memo } from 'react'

import { Icon, MenuOutline, Close } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func, string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

// Triangle Icon renders the glyph at its svgComponent's intrinsic size unless
// given one; the design calls for a 20px glyph inside the 32px button.
const ICON_SIZE = { width: '20', height: '20' }

function Hamburger({ isActive = false, onToggle, locale = 'en' }) {
  const t = (key) => i18n.t(key, { ns: 'rails', lng: locale })

  return (
    <button
      type="button"
      className="unified-nav__hamburger"
      aria-label={isActive ? t('navigation.aria.close_menu') : t('navigation.aria.open_menu')}
      aria-expanded={isActive}
      onClick={onToggle}
    >
      <Icon
        notSpaced
        color="dark"
        size={ICON_SIZE}
        svgComponent={isActive ? Close : MenuOutline}
      />
    </button>
  )
}

Hamburger.propTypes = {
  isActive: bool,
  onToggle: func.isRequired,
  locale: string,
}

export default memo(Hamburger)
